import styled from 'styled-components';
import dt from '../../../../shared/theme';
import { Separator } from '../../../shared/sectionable/styles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const SSeparator = styled(Separator)`
  margin-bottom: 32px;
`;

const SmallSeparator = styled.div`
  height: 0px;
  border-bottom: 1px solid #D7DFE7;
  margin: 0 0 16px 0;
  width: 100%;
`;

const Title = styled.div`
  font: ${props => dt(props).theme.fontWeightBold} 21px/120% ${props => dt(props).theme.fontFamilyBody};
  letter-spacing: 0.01em;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
`;

const ExternalLink = styled.a`
  font-size: 16px;
  font-weight: 700;
  height: 20px;
  margin-top: 4px;
  letter-spacing: 0;

  span.icon-lw-external-link {
    font-size: 12px;
    margin-right: 6px;
  }

  &:hover {
    cursor: pointer;
    text-decoration: none;

    > span {
      text-decoration: underline;

      &.icon-lw-external-link {
        text-decoration: none;
      }
    }
  }
`;

export {
  Container,
  SSeparator,
  SmallSeparator,
  Title,
  ExternalLink,
};
